import api from './api';

export interface BackupItem {
  filename: string;
  timestamp: string | null;
  size: number | null;
  sha256: string | null;
  source: string;
}

export interface BackupListResponse {
  backups: BackupItem[];
  source: string;
}

export interface BackupTriggerResponse {
  job_id: string;
  status: string;
  message: string;
}

export interface BackupStatusResponse {
  job_id: string;
  status: string;
}

export const backupsService = {
  list: async (source: 'local' | 'storage_box' | 'both' = 'both'): Promise<BackupListResponse> => {
    const response = await api.get<BackupListResponse>('/admin/backups', { params: { source } });
    return response.data;
  },

  trigger: async (localOnly = false, includeLogs = false): Promise<BackupTriggerResponse> => {
    const response = await api.post<BackupTriggerResponse>('/admin/backups', null, {
      params: { local_only: localOnly, include_logs: includeLogs },
    });
    return response.data;
  },

  getStatus: async (jobId: string): Promise<BackupStatusResponse> => {
    const response = await api.get<BackupStatusResponse>(`/admin/backups/status/${jobId}`);
    return response.data;
  },
};
